/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoDateRange implements angular.IDirective {
        restrict = "E";
        scope = {
            currentValue: "=ngModel",
            someCtrlFn: "&?",
            prevModel: "=",
            weekStartDay: "=?"
        };

        templateUrl = "app/components/controls/dateRangeTemplate.html";

        constructor() {

        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            //scope.today = () => {
            //    var current = moment();
            //    scope.currentValue.endDate = moment(current).add(7, 'days');
            //    scope.currentValue.startDate = current;
            //    scope.someCtrlFn()
            //}
            scope.stepWeekForward = () => {
                scope.prevModel = angular.copy(scope.currentValue);
                var current = scope.currentValue.endDate;
                scope.currentValue.endDate = moment(current).add(7, "days");
                scope.currentValue.startDate = current;
                if(scope.someCtrlFn) scope.someCtrlFn();

            }
            scope.stepWeekBackward = () => {
                scope.prevModel = angular.copy(scope.currentValue);
                var current = scope.currentValue.startDate;
                scope.currentValue.startDate = moment(current).subtract(7, "days");
                scope.currentValue.endDate = current;
                if (scope.someCtrlFn) scope.someCtrlFn();
            }

            scope.resetDate = () => {
                if (scope.weekStartDay == null)
                    scope.weekStartDay = 0;
                scope.currentValue.startDate = moment().day(scope.weekStartDay).startOf("day");
                scope.currentValue.endDate = moment().day(7 + scope.weekStartDay).startOf("day");
                if (scope.currentValue.startDate > moment()) {
                    scope.currentValue.startDate = scope.currentValue.startDate.subtract(7, 'day');
                    scope.currentValue.endDate = scope.currentValue.endDate.subtract(7, 'day');
                }

                if (scope.someCtrlFn) scope.someCtrlFn();
            }
        }

        
        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoDateRange();
            };

            //directive.$inject = ["$filter", "$compile"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoDateRange", MeevoDateRange.factory());
}